import { EmptyState } from '@/components/ui/EmptyState'
import { shortTime } from '@/lib/format'
import type { ActivityEvent } from '@/types/dashboard'

export function ActivityPulse({
  activity,
  embedded
}: {
  activity: ActivityEvent[]
  embedded?: boolean
}) {
  const body = !activity.length ? (
    <EmptyState title="Quiet" body="No recent capture events. Install the extension and browse a SaaS app." />
  ) : (
    <div className="pulse">
      {activity.slice(0, 40).map((a) => (
        <div className="pulse-item" key={a.id}>
          <div className="t">{shortTime(a.timestamp)}</div>
          <div className="b">
            <span className="pill teal">{a.type}</span> {a.label || ''}
          </div>
          <div className="d">
            {a.domain} · {a.sessionId?.slice?.(0, 18) || ''}
          </div>
        </div>
      ))}
    </div>
  )

  if (embedded) return <div className="embed-panel">{body}</div>
  return (
    <section className="block" id="pulse">
      <div className="section-head">
        <div>
          <h2>Activity pulse</h2>
          <p>Latest captured browser events.</p>
        </div>
      </div>
      {body}
    </section>
  )
}
